import {useQuery} from '@apollo/client';
import {useTranslation} from 'react-i18next';
import {normalizeLang} from '../../../../utils/i18nText';
import {
    GET_PICKUP_FAILURE_REASON_DICTIONARY,
    GetPickupFailureReasonDictionaryResponse
} from '../graphql/queries/getPickupFailureReasonDictionary';

/**
 * 揽收失败原因码 → 当前语言文案。
 * 字典取服务端异常字典全量接口，表格与详情共用（Apollo cache-first 只发一次请求）；
 * 字典未返回或码未收录时回落显示码本身。
 */
export const usePickupFailureReasonText = (): ((code: string) => string) => {
    const {i18n} = useTranslation();
    const lang = normalizeLang(i18n.language);
    const {data} = useQuery<GetPickupFailureReasonDictionaryResponse>(
        GET_PICKUP_FAILURE_REASON_DICTIONARY
    );
    const textByCode: Record<string, string> = {};
    (data?.getExceptionDictionaryAll || []).forEach(entry => {
        const localized =
            lang === 'es'
                ? entry.secondaryTypeEs
                : lang === 'en'
                  ? entry.secondaryTypeEn
                  : entry.secondaryTypeZh;
        // 缺当前语言时回落中文（与原 PickupEnum 口径一致）
        textByCode[entry.exceptionReasonCode] = localized || entry.secondaryTypeZh;
    });
    return (code: string) => textByCode[code] || code;
};
